import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";

import { createI18n } from 'vue-i18n';
import english from './languages/en';
import myanmar from './languages/my';
import CapitalizeDirective from './directives/capitalize';

const i18n = createI18n({
   locale: 'en', // default locale
   messages: {
     en: english,
     my: myanmar,
   },
 });

// router.beforeEach((to) => {
//    if (to.meta.requiresAuth && !store.getters["auth/isAuth"]) {
//       return {
//          path: "/",
//       };
//    }
// });

createApp(App)
   .directive('capitalize', CapitalizeDirective)
   .use(Quasar, quasarUserOptions)
   .use(store)
   .use(router)
   .use(i18n)
   .mount("#app");
